import React from 'react';
import styled from '@emotion/styled';
import {
  AdminPanelSettings,
  ArrowDropDown as MUIArrowDropdown,
  Expand,
  PeopleOutline,
  PersonOutline,
  Warning,
  Architecture,
  HomeOutlined,
} from '@mui/icons-material';
import { AllIconsType, designTokens, Icon } from '@platform-ui/design-system';
import { CUSTOM_OBJECTS_MENU_ID } from './hooks/useCustomObjectDefinition';

export const ZuoraLogo = () => (
  <svg
    aria-label="Zuora Logo Image"
    x="0px"
    y="0px"
    viewBox="0 0 429 88"
    enableBackground="new 0 0 429 88"
    xmlSpace="preserve"
    height="20"
    width="88"
    fill="none"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M399.543 64.9712L405.054 84.5495H428.984L404.764 2.46545H369.378L344.869 84.4045H368.218L373.584 64.8261H399.543V64.9712ZM386.636 18.4182L395.773 51.4839H377.5L386.636 18.4182Z"
      fill="white"
    />
    <path
      d="M76.2831 64.3906H41.9122L75.848 2.61005H3.19054V22.7685H36.8363L0 84.5491H76.2831V64.3906Z"
      fill="white"
    />
    <path
      d="M319.055 53.6591C322.826 53.514 326.596 52.4989 329.932 50.6135C333.558 48.5832 336.603 45.6827 338.634 41.912C340.809 37.7063 341.969 33.0655 341.824 28.2797C341.679 23.4939 340.374 18.9981 338.053 14.7924C335.443 10.7317 331.672 7.54115 327.322 5.5108C322.681 3.33543 317.17 2.17523 310.934 2.17523H264.961V84.5494H288.31V48.7282L311.804 84.8394H338.924L317.75 53.8041L319.055 53.6591ZM307.888 41.622H288.31V21.4635H307.888C310.499 21.4635 313.109 22.4787 314.995 24.364C316.88 26.2494 317.895 28.8598 317.895 31.4703C317.895 34.0807 316.88 36.6912 314.995 38.5765C313.109 40.4618 310.644 41.622 307.888 41.622Z"
      fill="white"
    />
    <path
      d="M211.592 0C186.502 0 166.779 19.1433 166.779 43.5075C166.779 67.8716 186.502 87.0149 211.592 87.0149C236.681 87.0149 256.259 67.8716 256.259 43.5075C256.404 19.1433 236.681 0 211.592 0ZM211.592 65.5512C207.241 65.5512 203.035 64.246 199.409 61.9256C195.784 59.4602 193.028 56.1246 191.288 52.0639C189.548 48.0032 189.113 43.6525 189.983 39.4468C190.853 35.241 192.883 31.3254 195.929 28.1348C198.974 25.0893 202.89 22.9139 207.241 22.1888C211.446 21.3187 215.942 21.7537 220.003 23.494C224.064 25.0893 227.399 27.9898 229.865 31.6154C232.33 35.241 233.635 39.4468 233.635 43.7975C233.635 49.5985 231.315 55.1095 227.254 59.3152C223.048 63.2309 217.393 65.5512 211.592 65.5512Z"
      fill="white"
    />
    <path
      d="M121.966 87.0145C131.538 87.0145 140.819 83.2439 147.636 76.4277C154.452 69.6115 158.222 60.475 158.222 50.9033V2.61005H134.728V53.2237C134.728 56.5593 133.423 59.8949 130.958 62.2153C128.492 64.6807 125.302 65.9859 121.966 65.9859C118.631 65.9859 115.295 64.6807 112.975 62.2153C110.654 59.7498 109.204 56.5593 109.204 53.2237V2.61005H85.71V50.9033C85.71 60.475 89.4806 69.6115 96.2968 76.4277C103.113 83.2439 112.25 87.0145 121.966 87.0145Z"
      fill="white"
    />
  </svg>
);

export const ZuoraRevenueLogo = () => (
  <svg
    width="161"
    height="20"
    viewBox="0 0 161 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#revenue)">
      <path
        d="M90.8052 14.7662L92.0577 19.2158H97.4964L91.9918 0.560333H83.9496L78.3793 19.1828H83.6859L84.9055 14.7332H90.8052V14.7662ZM87.8718 4.18596L89.9484 11.7009H85.7955L87.8718 4.18596Z"
        fill="white"
      />
      <path
        d="M17.3371 14.6342H9.5255L17.2382 0.593201H0.725123V5.17467H8.37189L0 19.2157H17.3371V14.6342Z"
        fill="white"
      />
      <path
        d="M72.5125 12.1953C73.3695 12.1623 74.2263 11.9316 74.9845 11.5031C75.8086 11.0417 76.5007 10.3824 76.9622 9.52547C77.4566 8.56963 77.7202 7.5149 77.6873 6.42722C77.6543 5.33954 77.3577 4.31776 76.8302 3.36192C76.237 2.43904 75.38 1.71391 74.3913 1.25247C73.3366 0.758067 72.0841 0.494385 70.6668 0.494385H60.2184V19.2158H65.525V11.0746L70.8645 19.2817H77.0282L72.2159 12.2282L72.5125 12.1953ZM69.9745 9.45956H65.525V4.87808H69.9745C70.5679 4.87808 71.1611 5.10881 71.5897 5.53729C72.0182 5.96579 72.2488 6.55906 72.2488 7.15236C72.2488 7.74563 72.0182 8.33892 71.5897 8.7674C71.1611 9.19588 70.6009 9.45956 69.9745 9.45956Z"
        fill="white"
      />
      <path
        d="M48.0891 0C42.3868 0 37.9043 4.35075 37.9043 9.88807C37.9043 15.4254 42.3868 19.7761 48.0891 19.7761C53.7911 19.7761 58.2407 15.4254 58.2407 9.88807C58.2736 4.35075 53.7911 0 48.0891 0ZM48.0891 14.898C47.1002 14.898 46.1443 14.6014 45.3202 14.074C44.4963 13.5137 43.87 12.7556 43.4745 11.8327C43.0791 10.9098 42.9802 9.92102 43.1779 8.96518C43.3757 8.00932 43.837 7.11941 44.5293 6.39427C45.2213 5.70211 46.1113 5.2077 47.1002 5.04291C48.0559 4.84516 49.0777 4.94402 50.0007 5.33955C50.9236 5.70211 51.6816 6.36132 52.242 7.18532C52.8023 8.00932 53.0988 8.96518 53.0988 9.95398C53.0988 11.2724 52.5716 12.5249 51.6486 13.4807C50.6927 14.3707 49.4075 14.898 48.0891 14.898Z"
        fill="white"
      />
      <path
        d="M27.7196 19.776C29.895 19.776 32.0043 18.9191 33.5536 17.3699C35.1027 15.8208 35.9596 13.7443 35.9596 11.5689V0.593201H30.62V12.0963C30.62 12.8544 30.3234 13.6125 29.7632 14.1398C29.2027 14.7002 28.4777 14.9968 27.7196 14.9968C26.9616 14.9968 26.2034 14.7002 25.6761 14.1398C25.1486 13.5795 24.8191 12.8544 24.8191 12.0963V0.593201H19.4796V11.5689C19.4796 13.7443 20.3365 15.8208 21.8856 17.3699C23.4348 18.9191 25.5114 19.776 27.7196 19.776Z"
        fill="white"
      />
    </g>
    <path
      d="M106.63 15H108.268V11.5532H110.083L111.879 15H113.752L111.752 11.3057C112.838 10.9121 113.479 9.90918 113.479 8.69678V8.68408C113.479 6.93848 112.298 5.84033 110.331 5.84033H106.63V15ZM108.268 10.2964V7.16699H110.127C111.168 7.16699 111.797 7.76367 111.797 8.72217V8.73486C111.797 9.71875 111.194 10.2964 110.159 10.2964H108.268ZM118.306 15.1396C120.191 15.1396 121.118 14.0542 121.34 13.1592L121.359 13.1021H119.854L119.835 13.1465C119.683 13.4639 119.194 13.8955 118.337 13.8955C117.265 13.8955 116.592 13.1719 116.573 11.9277H121.422V11.4072C121.422 9.3125 120.204 7.92871 118.229 7.92871C116.255 7.92871 114.992 9.35693 114.992 11.5405V11.5469C114.992 13.7559 116.243 15.1396 118.306 15.1396ZM118.249 9.1665C119.131 9.1665 119.772 9.73145 119.88 10.8677H116.585C116.706 9.76318 117.366 9.1665 118.249 9.1665ZM124.954 15H126.687L129.144 8.06201H127.48L125.887 13.4575H125.779L124.173 8.06201H122.485L124.954 15ZM133.418 15.1396C135.303 15.1396 136.23 14.0542 136.452 13.1592L136.471 13.1021H134.967L134.948 13.1465C134.795 13.4639 134.307 13.8955 133.45 13.8955C132.377 13.8955 131.704 13.1719 131.685 11.9277H136.535V11.4072C136.535 9.3125 135.316 7.92871 133.342 7.92871C131.368 7.92871 130.104 9.35693 130.104 11.5405V11.5469C130.104 13.7559 131.355 15.1396 133.418 15.1396ZM133.361 9.1665C134.243 9.1665 134.884 9.73145 134.992 10.8677H131.698C131.818 9.76318 132.479 9.1665 133.361 9.1665ZM138.365 15H139.946V10.9565C139.946 9.91553 140.53 9.25537 141.469 9.25537C142.428 9.25537 142.866 9.80127 142.866 10.8804V15H144.446V10.5122C144.446 8.86182 143.602 7.92871 142.053 7.92871C141.05 7.92871 140.384 8.37939 140.054 9.12207H139.946V8.06201H138.365V15ZM148.86 15.1396C149.863 15.1396 150.568 14.689 150.892 13.9463H151V15H152.58V8.06201H151V12.1055C151 13.1465 150.454 13.8066 149.432 13.8066C148.479 13.8066 148.08 13.2607 148.08 12.188V8.06201H146.499V12.5498C146.499 14.2002 147.299 15.1396 148.86 15.1396ZM157.73 15.1396C159.616 15.1396 160.542 14.0542 160.765 13.1592L160.784 13.1021H159.279L159.26 13.1465C159.108 13.4639 158.619 13.8955 157.762 13.8955C156.689 13.8955 156.017 13.1719 155.998 11.9277H160.847V11.4072C160.847 9.3125 159.628 7.92871 157.654 7.92871C155.68 7.92871 154.417 9.35693 154.417 11.5405V11.5469C154.417 13.7559 155.667 15.1396 157.73 15.1396ZM157.673 9.1665C158.556 9.1665 159.197 9.73145 159.305 10.8677H156.01C156.131 9.76318 156.791 9.1665 157.673 9.1665Z"
      fill="white"
      fillOpacity="0.8"
    />
    <defs>
      <clipPath id="revenue">
        <rect width="97.5" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const TrainingCenter = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
    <path
      fill="#fff"
      d="M22.47 6.95c-.47-.24-.96-.44-1.47-.61v12.03c-1.14-.41-2.31-.62-3.5-.62-1.9 0-3.78.54-5.5 1.58V7.23c-1.62-.93-3.49-1.48-5.5-1.48-1.79 0-3.48.44-4.97 1.2-.33.16-.53.51-.53.88v12.08c0 .58.47.99 1 .99.16 0 .32-.04.48-.12 1.21-.63 2.57-1.03 4.02-1.03 2.07 0 3.98.82 5.5 2 1.52-1.18 3.43-2 5.5-2 1.45 0 2.81.4 4.02 1.04.16.08.32.12.48.12.52 0 1-.41 1-.99V7.83c0-.37-.2-.72-.53-.88ZM10 18.37c-1.14-.41-2.31-.62-3.5-.62s-2.36.21-3.5.62V8.46c1.11-.47 2.28-.71 3.5-.71 1.2 0 2.39.25 3.5.72v9.9Zm9-16.12-5 5v9.5l5-4.5v-10Z"
    />
  </svg>
);

const Insights = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" focusable="false">
    <title>Zuora/Products/Insights</title>
    <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z" />
  </svg>
);

const Products = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" focusable="false">
    <title>Zuora/Products/Products</title>
    <path d="M18 2c1.05 0 2 .95 2 2v1h1v1h-1v1h1v1h-1v1h1v1h-1v10c0 1.05-.95 2-2 2H6c-1.05 0-2-.95-2-2v-1H2v-2h2v-4H2v-2h2V7H2V5h2V4a2 2 0 012-2h12zm0 2H6v16h12V4zm-2 2v6h-6V6h6z" />
  </svg>
);

const Billing = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" focusable="false">
    <title>Zuora/Products/Billing</title>
    <path d="M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5zM19 19.09H5V4.91h14v14.18zM6 15h12v2H6v-2zm0-4h12v2H6v-2zm0-4h12v2H6V7z" />
  </svg>
);

const Payments = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" focusable="false">
    <title>Zuora/Products/Payments</title>
    <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
  </svg>
);

const AdvancedPayments = () => (
  <svg
    width="23"
    height="19"
    viewBox="0 0 23 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 14H23V16H20V19H18V16H15V14H18V11H20V14ZM18 4V2H2V4H18ZM18 8H2V14H13V16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V2C0 0.89 0.89 0 2 0H18C18.5304 0 19.0391 0.210714 19.4142 0.585786C19.7893 0.960859 20 1.46957 20 2V9H18V8Z"
      fill="white"
    />
  </svg>
);

const Finance = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" focusable="false">
    <title>Zuora/Products/Finance</title>
    <path d="M20 2a2 2 0 012 2v16a2 2 0 01-2 2H4a2 2 0 01-2-2V4a2 2 0 012-2h16zm-9 11H4v7h7v-7zm9 0h-7v7h7v-7zM8.91 14.38l.71.71-1.41 1.41 1.41 1.41-.71.71-1.41-1.41-1.41 1.41-.71-.71 1.41-1.41-1.41-1.41.71-.71 1.41 1.41 1.41-1.41zM19 17v1h-5v-1h5zm0-2v1h-5v-1h5zm1-11h-7v7h7V4zm-9 0H4v7h7V4zm6 1v2h2v1h-2v2h-1V8h-2V7h2V5h1zm-7 2v1H5V7h5z" />
  </svg>
);

const CustomObjects = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" focusable="false">
    <title>Zuora/Products/CustomObjects</title>
    <path d="M11.99 19.005L4.62 13.275L3 14.535L12 21.535L21 14.535L19.37 13.265L11.99 19.005ZM12 16.465L19.36 10.735L21 9.465L12 2.465L3 9.465L4.63 10.735L12 16.465ZM12 4.995L17.74 9.465L12 13.935L6.26 9.465L12 4.995Z" />
  </svg>
);

const Reporting = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" focusable="false">
    <title>Zuora/Products/Reporting</title>
    <path d="M13 2.025v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zm-1 16.95c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92v-3.03c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53a6.95 6.95 0 01-5.45 2.62z" />
  </svg>
);

const Analytics = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" focusable="false">
    <title>Zuora/Products/Analytics</title>
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7v-7zm4-3h2v10h-2V7zm4 6h2v4h-2v-4z" />
  </svg>
);

const Marketplace = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" focusable="false">
    <title>Zuora/Products/Marketplace</title>
    <path d="M7.996 18c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-1.45-5c.75 0 1.41-.41 1.75-1.03l3.58-6.49a.996.996 0 00-.87-1.48h-14.8l-.94-2h-3.27v2h2l3.6 7.59-1.35 2.44c-.73 1.34.23 2.97 1.75 2.97h12v-2h-12l1.1-2h7.45zm-9.39-7h12.15l-2.76 5h-7.02l-2.37-5z" />
  </svg>
);

const Platform = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" focusable="false">
    <title>Zuora/Products/Platform</title>
    <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z" />
  </svg>
);

const RevPro = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" focusable="false">
    <title>Zuora/Products/RevPro</title>
    <path d="M19.28 12v1.095c1.027.255 1.543 1.045 1.578 1.905h-1.086c-.03-.625-.354-1.05-1.228-1.05-.83 0-1.326.38-1.326.925 0 .475.359.78 1.474 1.075 1.114.295 2.308.78 2.308 2.2 0 1.025-.761 1.59-1.72 1.775V21h-1.473v-1.085C16.864 19.71 16.06 19.095 16 18h1.08c.055.59.452 1.05 1.464 1.05 1.086 0 1.326-.55 1.326-.895 0-.465-.245-.905-1.473-1.205-1.37-.335-2.309-.91-2.309-2.065 0-.965.767-1.595 1.72-1.805V12h1.473zM21 2a1 1 0 011 1v8h-2V6a1.91 1.91 0 00-2-1.8A1.91 1.91 0 0016 6H8a1.91 1.91 0 00-2-1.8A1.91 1.91 0 004 6v12h10v2H3a1 1 0 01-1-1V3a1 1 0 011-1zm-9 6.25l.89 2.75h2.89l-2.34 1.7.9 2.75-2.34-1.7-2.34 1.7.9-2.75L8.22 11h2.89L12 8.25z" />
  </svg>
);

const Collect = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" focusable="false">
    <title>Zuora/Products/Collect</title>
    <path d="M12.1752482,7.05176985 C12.6266772,6.89376985 13.1162015,7.10776985 13.3285826,7.55276985 L13.3285826,7.55276985 L14.2809645,9.55276985 C14.4638218,9.93776985 14.3914408,10.4027698 14.1019167,10.7077698 L14.1019167,10.7077698 L13.8228688,10.9997698 L21.0476379,10.9997698 C21.4085906,10.9997698 21.7381148,11.2147698 21.9000197,11.5527698 C22.0609722,11.8917698 22.0266865,12.2977698 21.8095434,12.6007698 L21.8095434,12.6007698 L18.9523977,16.6007698 C18.7723975,16.8517698 18.4904925,16.9997698 18.1904922,16.9997698 L18.1904922,16.9997698 L7.71429136,16.9997698 C7.71429136,17.5517698 7.28762428,17.9997698 6.76190947,17.9997698 L6.76190947,17.9997698 L2.95238189,17.9997698 C2.42666709,17.9997698 2,17.5517698 2,16.9997698 L2,16.9997698 L2,8.99976985 C2,8.44776985 2.42666709,7.99976985 2.95238189,7.99976985 L2.95238189,7.99976985 L6.76190947,7.99976985 C7.16476701,7.99976985 7.50571973,8.26576985 7.64476749,8.63676985 L7.64476749,8.63676985 Z M5.80952758,9.99976985 L3.90476379,9.99976985 L3.90476379,15.9997698 L5.80952758,15.9997698 L5.80952758,9.99976985 Z M11.9942956,9.22276985 L7.71429136,10.7207698 L7.71429136,14.9997698 L17.7142914,14.9997698 L19.1428741,12.9997698 L10.571437,12.9997698 L10.571437,11.9997698 C10.5809609,11.7407698 10.66858,11.4837698 10.8514373,11.2937698 L10.8514373,11.2937698 L12.2704863,9.80276985 L11.9942956,9.22276985 Z" />
  </svg>
);

const Commerce = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" focusable="false">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z" />
  </svg>
);

const ProcessAI = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" focusable="false">
    <path d="M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z" />
  </svg>
);

const SystemHealth = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" focusable="false" fill="none">
    <path d="M4 13a1 1 0 100 2v-2zm2.58 1v1h.558l.293-.473L6.58 14zm1.549-2.5l.904-.428-.787-1.66-.967 1.561.85.527zm2.371 5l-.904.428 1.04 2.192.807-2.287-.943-.333zm3-8.5l.894-.447-1.053-2.107-.784 2.221L13.5 8zm6.5 7a1 1 0 100-2v2zm-3.5-1l-.894.447.276.553h.618v-1zM4 15h2.58v-2H4v2zm3.43-.473l1.55-2.5-1.701-1.053-1.548 2.5 1.7 1.053zm-.205-2.598l2.371 5 1.808-.857-2.371-5-1.808.857zm4.218 4.904l3-8.5-1.886-.666-3 8.5 1.886.666zM17.936 15H20v-2h-2.064v2zm-5.33-6.553l3 6 1.788-.894-3-6-1.788.894zM16.5 15h1.436v-2H16.5v2z" />
    <rect x={2} y={3} width={20} height={18} rx={1} strokeWidth={2} />
  </svg>
);

const RevenueDashboard = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 2V4H12.5V2H16.5ZM6.5 2V8H2.5V2H6.5ZM16.5 10V16H12.5V10H16.5ZM6.5 14V16H2.5V14H6.5ZM18.5 0H10.5V6H18.5V0ZM8.5 0H0.5V10H8.5V0ZM18.5 8H10.5V18H18.5V8ZM8.5 12H0.5V18H8.5V12Z"
      fill="white"
      fillOpacity="0.8"
    />
  </svg>
);

const RevenueSetup = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.71 10.97L4.91 13.04C4.99 13.17 5.14 13.22 5.28 13.17L6.77 12.57C7.08 12.81 7.41 13.01 7.78 13.16L8 14.75C8.03 14.89 8.15 15 8.3 15H10.7C10.85 15 10.97 14.89 11 14.74L11.22 13.15C11.58 13 11.92 12.8 12.23 12.56L13.72 13.16C13.86 13.21 14.01 13.16 14.09 13.03L15.29 10.96C15.37 10.83 15.33 10.67 15.22 10.57L13.95 9.58C13.98 9.39 13.99 9.19 13.99 9C13.99 8.8 13.97 8.61 13.95 8.41L15.22 7.42C15.33 7.33 15.37 7.16 15.29 7.03L14.09 4.96C14.01 4.83 13.86 4.78 13.72 4.83L12.23 5.43C11.92 5.19 11.59 4.99 11.22 4.84L11 3.25C10.97 3.11 10.85 3 10.7 3H8.3C8.15 3 8.03 3.11 8 3.26L7.78 4.85C7.42 5 7.07 5.19 6.77 5.43L5.28 4.83C5.14 4.78 4.99 4.83 4.91 4.96L3.71 7.03C3.63 7.16 3.67 7.32 3.78 7.42L5.05 8.41C5.02 8.61 5 8.8 5 9C5 9.2 5.02 9.39 5.04 9.59L3.77 10.58C3.66 10.68 3.63 10.84 3.71 10.97ZM9.5 7.29C10.44 7.29 11.21 8.06 11.21 9C11.21 9.94 10.44 10.71 9.5 10.71C8.56 10.71 7.79 9.94 7.79 9C7.79 8.06 8.56 7.29 9.5 7.29ZM16.5 0H2.5C1.39 0 0.5 0.9 0.5 2V16C0.5 17.1 1.39 18 2.5 18H16.5C17.61 18 18.5 17.1 18.5 16V2C18.5 0.9 17.61 0 16.5 0ZM16.5 16H2.5V2H16.5V16Z"
      fill="white"
      fillOpacity="0.8"
    />
  </svg>
);

const RevenuePolicies = () => (
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5 10.99L20.06 8.2L20.4 4.51L16.79 3.69L14.9 0.5L11.5 1.96L8.1 0.5L6.21 3.69L2.6 4.5L2.94 8.2L0.5 10.99L2.94 13.78L2.6 17.48L6.21 18.3L8.1 21.5L11.5 20.03L14.9 21.49L16.79 18.3L20.4 17.48L20.06 13.79L22.5 10.99ZM18.55 12.47L17.99 13.12L18.07 13.97L18.25 15.92L15.51 16.54L15.07 17.28L14.08 18.96L12.3 18.19L11.5 17.85L10.71 18.19L8.93 18.96L7.94 17.29L7.5 16.55L4.76 15.93L4.94 13.97L5.02 13.12L4.46 12.47L3.17 11L4.46 9.52L5.02 8.87L4.93 8.01L4.75 6.07L7.49 5.45L7.93 4.71L8.92 3.03L10.7 3.8L11.5 4.14L12.29 3.8L14.07 3.03L15.06 4.71L15.5 5.45L18.24 6.07L18.06 8.02L17.98 8.87L18.54 9.52L19.83 10.99L18.55 12.47Z"
      fill="white"
      fillOpacity="0.6"
    />
    <path
      d="M9.59 12.75L7.27 10.42L5.79 11.91L9.59 15.72L16.93 8.36L15.45 6.87L9.59 12.75Z"
      fill="white"
      fillOpacity="0.6"
    />
  </svg>
);

const RevenueForecast = () => (
  <svg
    width="23"
    height="18"
    viewBox="0 0 23 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5 5.5C19.05 5.5 18.24 6.94 18.57 8.01L15.02 11.57C14.72 11.48 14.28 11.48 13.98 11.57L11.43 9.02C11.77 7.95 10.96 6.5 9.5 6.5C8.05 6.5 7.23 7.94 7.57 9.02L3.01 13.57C1.94 13.24 0.5 14.05 0.5 15.5C0.5 16.6 1.4 17.5 2.5 17.5C3.95 17.5 4.76 16.06 4.43 14.99L8.98 10.43C9.28 10.52 9.72 10.52 10.02 10.43L12.57 12.98C12.23 14.05 13.04 15.5 14.5 15.5C15.95 15.5 16.77 14.06 16.43 12.98L19.99 9.43C21.06 9.76 22.5 8.95 22.5 7.5C22.5 6.4 21.6 5.5 20.5 5.5Z"
      fill="white"
      fillOpacity="0.6"
    />
    <path
      d="M14.5 6.5L15.44 4.43L17.5 3.5L15.44 2.57L14.5 0.5L13.58 2.57L11.5 3.5L13.58 4.43L14.5 6.5Z"
      fill="white"
      fillOpacity="0.6"
    />
    <path
      d="M3 8.5L3.5 6.5L5.5 6L3.5 5.5L3 3.5L2.5 5.5L0.5 6L2.5 6.5L3 8.5Z"
      fill="white"
      fillOpacity="0.6"
    />
  </svg>
);

const RevenueSSP = () => (
  <svg
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 15L20.5 11L16.5 7V10H11.44C11.1 6.9 9.18 4.28 6.5 2.95C6.46 1.31 5.14 0 3.5 0C1.84 0 0.5 1.34 0.5 3C0.5 4.66 1.84 6 3.5 6C4.45 6 5.28 5.55 5.83 4.86C7.73 5.9 9.1 7.77 9.42 10H6.32C5.9 8.84 4.8 8 3.5 8C1.84 8 0.5 9.34 0.5 11C0.5 12.66 1.84 14 3.5 14C4.8 14 5.9 13.16 6.32 12H9.42C9.1 14.23 7.73 16.1 5.84 17.14C5.28 16.45 4.45 16 3.5 16C1.84 16 0.5 17.34 0.5 19C0.5 20.66 1.84 22 3.5 22C5.14 22 6.46 20.69 6.49 19.05C9.17 17.72 11.09 15.1 11.43 12H16.5V15Z"
      fill="white"
      fillOpacity="0.6"
    />
  </svg>
);

const RevenueWorkbench = () => (
  <svg
    width="23"
    height="18"
    viewBox="0 0 23 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5 0H2.5C1.4 0 0.5 0.9 0.5 2V14C0.5 15.1 1.4 16 2.5 16H7.5V18H15.5V16H20.5C21.6 16 22.5 15.1 22.5 14V2C22.5 0.9 21.6 0 20.5 0ZM20.5 14H2.5V2H20.5V14ZM18.5 5H7.5V7H18.5V5ZM18.5 9H7.5V11H18.5V9ZM6.5 5H4.5V7H6.5V5ZM6.5 9H4.5V11H6.5V9Z"
      fill="white"
      fillOpacity="0.6"
    />
  </svg>
);

const RevenueAccounting = () => (
  <svg
    width="21"
    height="14"
    viewBox="0 0 21 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 7C9.43 7 11 5.43 11 3.5C11 1.57 9.43 0 7.5 0C5.57 0 4 1.57 4 3.5C4 5.43 5.57 7 7.5 7ZM7.5 2C8.33 2 9 2.67 9 3.5C9 4.33 8.33 5 7.5 5C6.67 5 6 4.33 6 3.5C6 2.67 6.67 2 7.5 2ZM7.55 12H3.27C4.26 11.5 5.97 11 7.5 11C7.61 11 7.73 11.01 7.84 11.01C8.18 10.28 8.77 9.68 9.48 9.2C8.75 9.07 8.06 9 7.5 9C5.16 9 0.5 10.17 0.5 12.5V14H7.5V12.5C7.5 12.33 7.52 12.16 7.55 12ZM15 9.5C13.16 9.5 9.5 10.51 9.5 12.5V14H20.5V12.5C20.5 10.51 16.84 9.5 15 9.5ZM16.21 7.68C16.97 7.25 17.5 6.44 17.5 5.5C17.5 4.12 16.38 3 15 3C13.62 3 12.5 4.12 12.5 5.5C12.5 6.44 13.03 7.25 13.79 7.68C14.15 7.88 14.56 8 15 8C15.44 8 15.85 7.88 16.21 7.68Z"
      fill="white"
      fillOpacity="0.6"
    />
  </svg>
);

const RevenueFileUpload = () => (
  <svg
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 0H2.5C1.4 0 0.51 0.9 0.51 2L0.5 18C0.5 19.1 1.39 20 2.49 20H14.5C15.6 20 16.5 19.1 16.5 18V6L10.5 0ZM14.5 18H2.5V2H9.5V7H14.5V18ZM4.5 13.01L5.91 14.42L7.5 12.84V17H9.5V12.84L11.09 14.43L12.5 13.01L8.51 9L4.5 13.01Z"
      fill="white"
      fillOpacity="0.6"
    />
  </svg>
);

const RevenueReports = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 0.0253906V3.05539C14.89 3.54539 17.5 6.44539 17.5 9.97539C17.5 10.8754 17.32 11.7254 17.02 12.5154L19.62 14.0454C20.18 12.8054 20.5 11.4254 20.5 9.97539C20.5 4.79539 16.55 0.525391 11.5 0.0253906ZM10.5 16.9754C6.63 16.9754 3.5 13.8454 3.5 9.97539C3.5 6.44539 6.11 3.54539 9.5 3.05539V0.0253906C4.44 0.525391 0.5 4.78539 0.5 9.97539C0.5 15.4954 4.97 19.9754 10.49 19.9754C13.8 19.9754 16.73 18.3654 18.55 15.8854L15.95 14.3554C14.67 15.9554 12.71 16.9754 10.5 16.9754Z"
      fill="white"
      fillOpacity="0.6"
    />
  </svg>
);

const RevenueDataInterface = () => (
  <svg
    width="21"
    height="16"
    viewBox="0 0 21 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 16H20.5V12H0.5V16ZM2.5 13H4.5V15H2.5V13ZM0.5 0V4H20.5V0H0.5ZM4.5 3H2.5V1H4.5V3ZM0.5 10H20.5V6H0.5V10ZM2.5 7H4.5V9H2.5V7Z"
      fill="white"
      fillOpacity="0.6"
    />
  </svg>
);

const RevenueIntegrationHub = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M7.996 18c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-1.45-5c.75 0 1.41-.41 1.75-1.03l3.58-6.49a.996.996 0 00-.87-1.48h-14.8l-.94-2h-3.27v2h2l3.6 7.59-1.35 2.44c-.73 1.34.23 2.97 1.75 2.97h12v-2h-12l1.1-2h7.45zm-9.39-7h12.15l-2.76 5h-7.02l-2.37-5z"
      fill="black"
      fillOpacity="0.6"
    />
  </svg>
);

const RevenueIcons = {
  dashboard: RevenueDashboard,
  setups: RevenueSetup,
  policies: RevenuePolicies,
  forecast: RevenueForecast,
  ssp: RevenueSSP,
  workbench: RevenueWorkbench,
  accounting: RevenueAccounting,
  'file upload': RevenueFileUpload,
  reports: RevenueReports,
  'data interface': RevenueDataInterface,
  'integration hub': RevenueIntegrationHub,
};

const iconMap = {
  'Zuora/Home': HomeOutlined,
  'Zuora/Customers': PeopleOutline,
  'Zuora/Insights': Insights,
  'Zuora/TrainingCenter': TrainingCenter,
  'Zuora/Products': Products,
  'Zuora/Billing': Billing,
  'Zuora/Payments': Payments,
  'Zuora/AdvancedPayments': AdvancedPayments,
  'Zuora/Finance': Finance,
  [CUSTOM_OBJECTS_MENU_ID]: CustomObjects,
  'Zuora/Reporting': Reporting,
  'Zuora/Analytics': Analytics,
  'Zuora/MyConnect': Marketplace,
  'Zuora/Collections': Collect,
  'Zuora/Workflow': Platform,
  'Zuora/RevPro': RevPro,
  'Zuora/RevenueOnboarding': RevPro,
  'Zuora/CustomerAdmin': PersonOutline,
  'Zuora/Admin': AdminPanelSettings,
  'Zuora/Portlet': Expand,
  'Zuora/Commerce': Commerce,
  'Zuora/ProcessAI': ProcessAI,
  'Zuora/UsageMediation': Architecture,
  'Zuora/__ERROR': Warning,
  'Zuora/SystemHealth': SystemHealth,
  'Zuora/Extensions': Expand,
  'SSPAI/Dashboard': RevenueDashboard, //TODO - Expose list of stock icons as ids for Generic Apps. Custom icons can be added based on request
  'SSPAI/Analyzer': RevenueSSP,
  'SSPAI/Source': RevenueFileUpload,
  ...RevenueIcons,
};

interface ProductAreaIconProps {
  area?: string;
  icon?: AllIconsType;
  active: boolean;
}

const IconWrapper = styled.span<{ $active: boolean }>`
  height: 56px;
  width: 56px;
  min-width: 56px;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: ${({ $active }) => ($active ? "''" : 'none')};
    border-left: 4px solid ${designTokens.colors.teal300};
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  path {
    fill: ${designTokens.colors.darkEmphasisExtraMedium};
  }

  rect {
    stroke: ${designTokens.colors.darkEmphasisExtraMedium};
  }
`;

export const ProductAreaIcon: React.FC<ProductAreaIconProps> = ({
  area,
  active,
  icon,
}: ProductAreaIconProps) => {
  const iconProps = {
    $active: active,
    // mark the icon as non-interactive and non-important for screen readers
    'aria-hidden': true,
  };

  const ProvidedIcon = icon ? (
    <IconWrapper {...iconProps}>
      <Icon body={icon} />
    </IconWrapper>
  ) : undefined;

  if (ProvidedIcon) {
    return ProvidedIcon;
  }

  const AreaMapIcon = area ? iconMap[area] : undefined;

  if (!AreaMapIcon) {
    return <IconWrapper {...iconProps} />;
  }

  return (
    <IconWrapper {...iconProps}>
      <AreaMapIcon />
    </IconWrapper>
  );
};

export const ArrowDropdown = styled(MUIArrowDropdown)`
  fill: ${designTokens.colors.white};
`;
